import { render, staticRenderFns } from "./template-deliveryUnit-budgetItem.vue?vue&type=template&id=22dbd103&"
import script from "./template-deliveryUnit-budgetItem.vue?vue&type=script&lang=js&"
export * from "./template-deliveryUnit-budgetItem.vue?vue&type=script&lang=js&"
import style0 from "./template-deliveryUnit-budgetItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports